import groq from 'groq'
export function callToAction() {
	return groq`
    {
      label,
      "icon": icon->slug,
      "to": link[0]{
        "type": _type,
        "url": url,
        "slug": select(
          ^.link[0]->._type == 'page.landing' => '',
          ^.link[0]->metadata.slug.current
        ),
        "document": ^.link[0]->._type,
        actionType,
      }
    }
  `
}
